import { useState } from 'react';
import { UpdateUserPayload, usersService } from '../../../apiServices/users.service';

export const useUpdateUser = () => {
  const [loading, setLoading] = useState(false);

  const updateUser = async (id: number, payload: UpdateUserPayload) => {
    setLoading(true);

    try {
      return await usersService.update(id, payload);
    } finally {
      setLoading(false);
    }
  };

  return {
    updateUser,
    loading,
  };
};
